// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/Group 3804.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css */
body {
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
  color: #FAC8FF;
}

.welcome {
  margin-top: 10px;
  margin-left: 100px;
  color: white;
  width: 40%;
  height: 30px;
}

/* .main-login{
  display: flex;
  flex-direction: column;
  align-items: center;
} */
.checkbox {
  margin-top: 3px;
  font-size: 15px;
  font-family: "Roboto", sans-serif;
  color: #FAC8FF;
}

.avatar {
  width: 20%;
  margin: 20px;
}

.acce {
  width: 50%;
}

.user-img {
  width: 10%;
  margin-top: 15px;
  height: 15px;
}

.pass-img {
  width: 7%;
  margin-right: 10px;
  margin-top: 18px;
  height: 15px;
}

.main-L {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace 'background.jpg' with your image file */
  background-size: cover;
  background-position: center;
  min-height: calc(100vh - 20px);
}

.login-container {
  position: absolute;
  top: 60%;
  left: 80%;
  width: 18%;
  height: 10%;
  /* height: 20%;
  width: 20%; */
  transform: translate(-50%, -50%);
  background: rgb(41, 5, 63);
  /* border: 1px solid white; */
  padding: 5px;
  border-radius: 25px;
  align-items: center;
  /* margin-top: 20px; */
  color: white;
  font-size: 22px;
  font-family: Graphik;
  font-weight: 400;
  border: none;
}

.title-login {
  transform: translate(215%, 200%);
  display: flex;
  flex-direction: column;
  /* position: absolute; */
  width: 30%;
  height: 10%;
  top: 60%;
  left: 80%;
  /* display: flex;
  flex-direction: column;
  max-width: 345px;
  margin-left: 142vh;
  padding-top: 130px; */
}

.user-tag {
  display: flex;
  margin-top: 6px;
  flex-direction: row;
  width: 100%;
}

.form-group label {
  font-size: 14px;
  width: 100%;
  margin-bottom: 5px;
  font-weight: 200;
  font-style: Graphik;
}

.form-group input {
  padding: 10px;
  font-size: 16px;
  border: none;
  margin-bottom: 10px;
  background-color: transparent;
  color: rgb(41, 5, 63);
  width: 230px;
  border-bottom: 1px solid gray;
}

.form-group input:focus {
  color: rgb(41, 5, 63);
  padding: 10px;
  font-size: 16px;
  border: none;
  margin-bottom: 10px;
  border-bottom: 1px solid gray;
  background-color: transparent;
  outline: none;
}

.password {
  text-decoration: none;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  margin-right: 4px;
  color: rgb(41, 5, 63);
}

.remember-forgot {
  display: flex;
  margin-top: 10px;
  margin-left: 130px;
}

.form-group input::placeholder {
  color: gray;
}

.button-l {
  background: rgb(41, 5, 63);
  width: 90%;
  height: 45px;
  border-radius: 20px;
  margin-top: 20px;
  color: white;
  font-size: 17px;
  font-family: Graphik;
  font-weight: 400;
  border: none;
}

.remember-forgot label {
  font-size: 14px;
}

.watermark {
  position: absolute;
  bottom: 0;
  right: 0;
  padding-right: 530px;
  color: white;
  font-size: 12px;
  opacity: 0.5;
  justify-content: center;
  align-items: center;
}

.login-label {
  color: rgb(41, 5, 63);
  line-height: 10px;
  font-weight: 500;
  font-size: 14px;
  font-family: Graphik;
  margin-top: 20px;
  margin-right: 200px;
}

.azureicon {
  width: 27px;
  margin-right: 10px;
  margin-bottom: 3px;
}

.button-login {
  background: rgb(41, 5, 63);
  width: 90%;
  height: 45px;
  border-radius: 20px;
  margin-top: 20px;
  color: white;
  font-size: 17px;
  font-family: Graphik;
  font-weight: 400;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/login.scss"],"names":[],"mappings":"AAAA,cAAA;AAEA;EACI,SAAA;EACA,UAAA;EACA,iCAAA;EACA,cAAA;AAAJ;;AAEI;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;AACN;;AACI;;;;GAAA;AAKA;EACE,eAAA;EACA,eAAA;EACA,iCAAA;EACA,cAAA;AAEN;;AAAI;EACE,UAAA;EACA,YAAA;AAGN;;AADI;EACE,UAAA;AAIN;;AAFI;EACE,UAAA;EACA,gBAAA;EACA,YAAA;AAKN;;AAHI;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAMN;;AAJI;EACE,yDAAA,EAAA,kDAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;AAON;;AALI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA;eAAA;EAEA,gCAAA;EACA,0BAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;AAQN;;AALI;EACE,gCAAA;EACA,aAAA;EACD,sBAAA;EACC,wBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACD;;;;uBAAA;AAYL;;AAJE;EACE,aAAA;EACA,eAAA;EACE,mBAAA;EACA,WAAA;AAON;;AAJI;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAON;;AAJI;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;AAON;;AALI;EACE,qBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,aAAA;AAQN;;AANM;EACE,qBAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AASR;;AAPI;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AAUN;;AARI;EACE,WAAA;AAWN;;AATI;EACE,0BAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;AAYN;;AATI;EACE,eAAA;AAYN;;AATI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACF,uBAAA;EACA,mBAAA;AAYJ;;AAVI;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AAaN;;AAXG;EACC,WAAA;EACA,kBAAA;EACA,kBAAA;AAcJ;;AAZG;EACE,0BAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;AAeL","sourcesContent":["/* Login.css */\n\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: 'Roboto', sans-serif;\n    color: #FAC8FF;\n  }\n    .welcome{\n      margin-top: 10px;\n      margin-left: 100px;\n      color: white;\n      width: 40%;\n      height: 30px;\n    }\n    /* .main-login{\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    } */\n    .checkbox{\n      margin-top: 3px;\n      font-size: 15px;\n      font-family: 'Roboto', sans-serif;\n      color: #FAC8FF;\n    }\n    .avatar{\n      width: 20%;\n      margin: 20px;\n    }\n    .acce{\n      width: 50%;\n    }\n    .user-img{\n      width: 10%;\n      margin-top: 15px;\n      height: 15px;\n    }\n    .pass-img{\n      width: 7%;\n      margin-right: 10px;\n      margin-top: 18px;\n      height: 15px;\n    }\n    .main-L{\n      background-image: url('./images/Group\\ 3804.png'); /* Replace 'background.jpg' with your image file */\n      background-size: cover;\n      background-position: center;\n      min-height: calc(100vh - 20px);\n    }\n    .login-container {\n      position: absolute;\n      top: 60%;\n      left: 80%;\n      width: 18%;\n      height: 10%;\n      /* height: 20%;\n      width: 20%; */\n      transform: translate(-50%, -50%);\n      background: rgba(41, 5, 63, 1);\n      /* border: 1px solid white; */\n      padding: 5px;\n      border-radius: 25px;   \n      align-items: center;\n      /* margin-top: 20px; */\n      color : white;\n      font-size: 22px;\n      font-family: Graphik;\n      font-weight: 400;\n      border: none;\n    }\n  \n    .title-login{\n      transform: translate(215%, 200%);\n      display: flex;\n     flex-direction: column;\n      /* position: absolute; */\n      width: 30%;\n      height: 10%;\n      top: 60%;\n      left: 80%;\n     /* display: flex;\n     flex-direction: column;\n     max-width: 345px;\n     margin-left: 142vh;\n     padding-top: 130px; */\n    }\n   \n    \n  .user-tag{\n    display: flex;\n    margin-top: 6px;\n      flex-direction: row;\n      width: 100%;\n  }\n    \n    .form-group label {\n      font-size: 14px;\n      width: 100%;\n      margin-bottom: 5px;\n      font-weight: 200;\n      font-style: Graphik;\n    }\n    \n    .form-group input {\n      padding: 10px;\n      font-size: 16px;\n      border: none;\n      margin-bottom: 10px;\n      background-color: transparent;\n      color: rgba(41, 5, 63, 1);\n      width: 230px;\n      border-bottom: 1px solid gray;\n    }\n    .form-group input:focus{\n      color:rgba(41, 5, 63, 1);\n      padding: 10px;\n      font-size: 16px;\n      border: none;\n      margin-bottom: 10px;\n      border-bottom: 1px solid gray;\n      background-color: transparent;  \n      outline: none; \n    }\n      .password{\n        text-decoration: none;\n        font-family: 'Roboto', sans-serif;\n        font-size: 12px;\n        margin-right: 4px;\n        color: rgba(41, 5, 63, 1);\n      }\n    .remember-forgot {\n      display: flex;\n      margin-top: 10px;\n      margin-left: 130px;\n    }\n    .form-group input::placeholder{\n      color: gray;\n    }\n    .button-l{\n      background: rgba(41, 5, 63, 1);\n      width: 90%;\n      height: 45px;\n      border-radius: 20px;\n      margin-top: 20px;\n      color : white;\n      font-size: 17px;\n      font-family: Graphik;\n      font-weight: 400;\n      border: none;\n    }\n    \n    .remember-forgot label {\n      font-size: 14px;\n    }\n    \n    .watermark {\n      position: absolute;\n      bottom: 0;\n      right: 0;\n      padding-right: 530px;\n      color: white;\n      font-size: 12px;\n      opacity: 0.5;\n    justify-content: center;\n    align-items: center;\n    }\n    .login-label{\n      color: rgba(41, 5, 63, 1);\n      line-height: 10px;\n      font-weight: 500;\n      font-size: 14px;\n      font-family: Graphik;\n      margin-top: 20px;\n      margin-right: 200px;\n    }\n   .azureicon{\n    width:27px;\n    margin-right: 10px;\n    margin-bottom: 3px;\n   }\n   .button-login{\n     background: rgba(41, 5, 63, 1);\n     width: 90%;\n     height: 45px;\n     border-radius: 20px;\n     margin-top: 20px;\n     color : white;\n     font-size: 17px;\n     font-family: Graphik;\n     font-weight: 400;\n     border: none;\n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
